(function(){
  // ✅ voeg hier alles toe wat je niet wilt meetellen
  const EXCLUDED_HANDLES = new Set([
    'verzekerde-verzending',
    'shipping-protection'
  ]);

  function render(n){
    const el = document.getElementById('TreeBanner');
    if (!el) return;

    if (n === 0){
      el.style.display = 'none';
      return;
    }

    el.style.display = '';

    // Altijd Engels
    el.innerHTML = `🌳 We plant <strong>${n}</strong> ${n === 1 ? 'tree' : 'trees'} in your name!`;
  }

  function refresh(){
    fetch('/cart.js')
      .then(r => r.json())
      .then(c => {
        let validCount = 0;

        if (Array.isArray(c.items)){
          c.items.forEach(item => {
            if (item && !EXCLUDED_HANDLES.has(item.handle)){
              validCount += Number(item.quantity) || 0;
            }
          });
        }

        render(validCount);
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded',        refresh);
  document.addEventListener('cart:updated',            refresh);
  document.addEventListener('ajaxProduct:added',       refresh);
  document.addEventListener('ajaxCart:cartUpdate',     refresh);
})();